import type { InboxFullMessageFragment } from "@qw/graphql";
import type { FC } from "react";

import { MessageHtml } from "@/message/message-html";

export interface DraftEditorReferenceMessageContentProps {
  message: InboxFullMessageFragment;
}

export const DraftEditorReferenceMessageContent: FC<DraftEditorReferenceMessageContentProps> = ({ message }) => {
  return <MessageHtml html={message.html} text={message.text} />;
};
